import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { isURL } from 'validator'
import { Input, Button, Form } from '@drifthq/tide-core'
import Launcher from '@drifthq/integrated-help-launcher'
import config from 'config'

import InstallNotification from 'components/OnboardingInstallNotification'
import NotificationModal from 'components/NotificationModalExp'
import * as OrgActions from 'modules/org/actions'
import { verifyWidgetSnippet } from 'modules/snippet/api'

import { track, page } from 'utils/trackingUtils'

import './style.css'

const SUCCESS_MESSAGE = 'Woohoo! Drift is successfully installed on your site.'
const ERROR_MESSAGE = 'We couldn’t verify that Drift is installed at this URL. Double check the URL and try again!'
const DESCRIPTION_COPY = 'Enter the URL where you installed Drift and we’ll check to make sure it was installed correctly.'

class InstallVerifyStep extends Component {
  constructor(props) {
    super(props)
    this.state = {
      verificationUrl: '',
      isValidVerificationUrl: false,
      verified: null,
      loading: false,
    }
  }

  componentDidMount = () => {
    page('Onboarding Verify Setup', {
      context: 'widget-onboarding'
    })
  }

  onVerifyClickExp = () => {
    this.props.actions.updateOrgProperties({ properties: { signUpDone: true }, redirect: true })
  }

  verifyWidget = () => {
    const { verificationUrl } = this.state

    this.setState({ loading: true })

    const onSuccess = (response) => {
      this.setState({ verified: response.ok, loading: false })
      if (response.ok) {
        track('JS Verification Succeeded', {
          context: 'widget-onboarding',
          verificationUrl: verificationUrl
        })
      this.props.actions.updateOrgProperties({ properties: { signUpDone: true } })
      } else if (!response.ok) {
        track('JS Verification Failed', {
          context: 'widget-onboarding',
          verificationUrl: verificationUrl
        })
      }
    }

    const onFailure = (err) => {
      console.warn(err)
      this.setState({ verified: false, loading: false })
      track('JS Verification Failed', {
        context: 'widget-onboarding',
        verificationUrl: verificationUrl
      })
    }

    verifyWidgetSnippet(verificationUrl, false)
      .then(onSuccess)
      .catch(onFailure)
  }

  onVerifyUrlChanged = (event) => {
    const value = event.target ? event.target.value : ''

    this.setState({ verificationUrl: value, isValidVerificationUrl: isURL(value) })
  }

  onHelpWidgetClick = () => {
    window.drift.api.startInteraction({interactionId: config.INTERACTION_ID})
  }

  onSkip = () => {
    track('Skipped JS Verification', {
      context: 'widget-onboarding',
      verificationUrl: this.state.verificationUrl
    })
    this.props.actions.updateOrgProperties({ properties: { signUpDone: true }, redirect: true })
  }

  render() {
    const { verificationUrl, isValidVerificationUrl, verified, loading } = this.state
    return (
      <Form onSubmit={this.verifyWidget}>
        <h1 className="touchless-verify-install-exp-header">Verify your Drift installation</h1>
        <p className="touchless-verify-install-body--title">{DESCRIPTION_COPY}</p>
        <div>
          <div className="touchless-verify-install-url-container">
            <Input
              className="touchless-verify-install-input"
              onChange={this.onVerifyUrlChanged}
              value={verificationUrl}
              placeholder="http://yourwebsite.com"
              label="Website URL"
              autofocus="autofocus"
            />
          </div>
          <InstallNotification
            className="touchless-verify-install-notification"
            errorText={ERROR_MESSAGE}
            isError={verified === false}
            isSuccess={false}
            successText={SUCCESS_MESSAGE}
          />
        </div>
        { !verified &&
          <Button
            className="touchless-verify-install-button"
            submit
            disabled={!isValidVerificationUrl}
            loading={loading}
          >
            Verify
          </Button>
        }
        { verified &&
          <Button
            className="touchless-verify-install-button"
            onClick={this.onVerifyClickExp}
          >
            Continue to Dashboard
          </Button>
        }
        {(verified === false) && <a className="touchless-verify-next" onClick={this.onSkip}>Continue to dashboard</a>}
        <NotificationModal showModal={verified} text="You installed Drift successfully 🎉" />
        <div onClick={this.onHelpWidgetClick}>
          <Launcher interactionId={config.INTERACTION_ID}/>
        </div>
      </Form>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    updateOrgProperties: OrgActions.updateOrgProperties,
    updateOrgPropertiesExp: OrgActions.updateOrgPropertiesExp
  }, dispatch),
})

export default connect(undefined, mapDispatchToProps)(InstallVerifyStep)



// WEBPACK FOOTER //
// ./src/layouts/InstallVerifyStep/index.js